<!-- Basic form table template this is the base form which is reponsible for rendering all the forms
used as base for building all the CURD datatable form
v1.0
-->
<template>
  <div class="formViewer">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <div class="headline">FORM NAME</div>
        <v-spacer></v-spacer>

        <v-flex lg12>
<addDialogSurvey></addDialogSurvey>
        </v-flex>
        <!-- table -->
        <v-flex lg12>
          <v-data-table :loading="loading" :headers="headers" :items="userData" class="elevation-1">
            <template v-slot:no-data>
              <v-alert :value="true" color="error" icon="warning">Sorry, nothing to display here :(</v-alert>
            </template>

            <!-- Generate table data based on the header column -->
            <template v-slot:items="props">

               <template v-for="(item, index) in headers">
                  <td
                    v-if="item.value != 'action'"
                    v-bind:key="item.value"
                    class="text-xs-center text-ms-center"
                  >{{ props.item[''+item.value]}}</td>
                </template>
            
              <td class="justify-center layout px-0">
                <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                <v-icon small @click="deleteItem(props.item)">delete</v-icon>
              </td>
            </template>


          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import addDialogSurvey from "../components/FormViewerSurveyDialog.vue";
import config from "../config.js"

const serverHost = config.backendServerHost;




export default {
   mounted() {
    this.loadTableForm();
  },
  components: {
    addDialogSurvey
  },
  methods: {
    onClickChild(value) {
      console.log(value); // someValue
      //alert(JSON.stringify(value));
      this.userData.push(JSON.parse(value));
    },
    deleteItem(value) {
      this.userData.pop(value);
    },

  loadTableForm()
  {
       //send request
      this.$axios
        .post(serverHost+"/formManager/get", '{}')
        .then((response) => {
          console.log(response);
          if(response.status==200)
          {
          this.userData.push(response.data.data);
          }
        })
        .catch((error) =>{
          console.log(error);
        });
  }

  },
  data() {
    return {
      loading: true,
      headers: [
        {
          text: "Submited Date",
          align: "center",
          sortable: false,
          value: "createdDate"
        },
        { text: "submited by", align: "center", value: "user" },
        { text: "state", align: "center", value: "state" },
        { text: "city", align: "center", value: "city" },
        { text: "branch", align: "center", value: "branch" },
        { text: "Actions", align: "center", value: "action", sortable: false }
        
      ],
      userData: [
        {
          userName: "asd",
          mobileNumber: "asd",
          city: "",
          branch: "",
          userType: ""
        }
      ]
    };
  }
};
</script>
